import { Component, Input, ViewChild } from '@angular/core';
import { JobPosting } from '@app/models/recruiting/job-posting.model';
import { ConsentForm } from '@app/modules/forms/applicant-tracker/components';
import { AuthService, NotifyService } from '@app/services';

@Component({
    selector: 'app-consent-card',
    templateUrl: './consent-card.component.html',
    styleUrls: ['./consent-card.component.scss'],
})
export class ConsentCardComponent {
    @ViewChild('applicantConsentForm') applicantConsentForm: ConsentForm;
    @Input() jobPosting: JobPosting;
    isLoading = false;

    constructor(
        private notify: NotifyService,
        private auth: AuthService
    ) {}

    async onSaveConsentForm(): Promise<void> {
        if (!this.jobPosting.isDirty() || !this.isApplicantConsentValid()) {
            return;
        }

        this.isLoading = true;
        try {
            await this.jobPosting.param('company', this.auth.company.id).save();
            this.notify.success('applicant-tracker.jobPostingSaved');
        } catch (err) {
            this.notify.error(err.message || 'applicant-tracker.couldNotSaveJobPosting');
        } finally {
            this.isLoading = false;
        }
    }

    private isApplicantConsentValid(): boolean {
        if (!this.applicantConsentForm) {
            return false;
        }

        this.applicantConsentForm.submit();
        return this.applicantConsentForm.valid;
    }
}
